<template>
  <div>
    <canvas id="chartPieFontes" ></canvas>
  </div>
</template>

<script>
import Api from '@/api/vue-exemplo'
import Chart from 'chart.js'

export default {
  //extends: Bar,
  mounted () {
    this.getTotalFontes();
    setTimeout(()=>{      
      this.addChartPie();
    }, 1200);
      
  },
  data: () => ({
    totalFontes : 0
  }),
  methods: {
    getTotalFontes () {
      Api.getTotalFontes()
        .then(response => {
          this.totalFontes = response.data.conteudo
        })
        .catch(error => {
          console.log(error)
          return 0
        })
    },
    addChartPie() {
      let perc =  this.totalFontes
      if (this.chartPieFontes) {
        this.chartPieFontes.data.datasets[0].data = [perc, 30000 - perc]
        this.chartPieFontes.update()
      } else {
        let ctx = document.getElementById('chartPieFontes').getContext('2d')
        this.chartPieFontes = new Chart(ctx, {
          type: 'pie',
          data: {
            labels: ['Fontes Protegidas', 'A proteger'],
            datasets: [{
              label: 'Extensão',
              data: [perc, 30000 - perc],
              backgroundColor: ['rgb(0, 128, 0)', 'rgb(28, 28, 28)']
            }]
          },
            options: {
              title: {
                display: true,
                text: "Porcentagem de Fontes Protegidas"
              },
              tooltips: {
                callbacks: {
                  label: function(tooltipItem, data) {
                    return data['labels'][tooltipItem['index']] + ': ' + data['datasets'][0]['data'][tooltipItem['index']] + '';
                  }
                }
              }
          }
        })
      }
    }

  }
};
</script>